/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
   
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using state config file
// import tailwindConfig from "../../tailwind.config.js"

const getBookmark = list => {
  const l = []
  list.forEach(i => {
    if (i.bookmark) {
      const j = {...i}
      delete j.items
      delete j.submenu
      l.push(j)
    }
    if ((i.items && i.items.length) || (i.submenu && i.submenu.length)) {
      l.push(...getBookmark(i.items || i.submenu))
    }
  })
  return l
}

const getters = {

  // COMPONENT
  // vx-autosuggest
  starredPages: state => getBookmark(state.navMenuItems),
  windowBreakPoint: (state) => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },
  AppActiveUser: state => state.auth.user,
}

export default getters
